<template>
  <div id="app" class="app-container" :class="currentLang == 'en' ? 'en-container' : ''">
    <router-view v-if="isRouterAlive" :currentLang="currentLang" />
  </div>
</template>

<script>
export default {
  name: "App",
  provide() {
    return {
      reloadApp: this.reloadApp,
      changeAppLanguage: this.changeAppLanguage,
      toVisualBudgetCenter: this.toVisualBudgetCenter,
    };
  },
  components: {},
  data() {
    return {
      isRouterAlive: true,
      currentLang: globalUrl.VUE_LANG,
    };
  },
  created() {
    this.setLanguage();
  },
  methods: {
    setRem() {
      // 当前页面屏幕分辨率相对于 1920宽的缩放比例，可根据自己需要修改
      var width = localStorage.documentWidth ? localStorage.documentWidth : document.documentElement.clientWidth;
      const scale = width / 1920;
      // 设置页面根节点字体大小（“Math.min(scale, 2)” 指最高放大比例为2，可根据实际业务需求调整）
      // console.log(16 * Math.min(scale, 2) - 0.17);
      document.documentElement.style.fontSize = 16 * Math.min(scale, 2) + 'px';
    },
    // 设置语言
    setLanguage() {
      // if (this.$vueCookies.get("lang") == undefined) {
      //   this.$vueCookies.set("lang", globalUrl.VUE_LANG || "en");
      // }
      // if(location.host.substring(location.host.lastIndexOf('.')) == '.cn') { // cn域名默认中文
      //   this.$i18n.locale = 'cn';
      //   this.currentLang = 'cn';
      // } else {
      //   this.$i18n.locale = navigator.language == 'zh-CN' ? 'cn' : 'en';
      //   this.currentLang = navigator.language == 'zh-CN' ? 'cn' : 'en';
      // }
    },
    // 切换语言
    changeAppLanguage(lang) {
      localStorage.setItem("lang", lang);
      this.$i18n.locale = lang;
      this.currentLang = lang;
      this.reloadApp();
    },
    reloadApp() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    // 立即试用-立即体验
    toVisualBudgetCenter() {
      if (localStorage.user_name) {
        // this.$router.push("/visualBudgetCenter");
      } else {
        this.$confirm(
          this.$t("message.header.loginTips"),
          this.$t("message.tips"),
          {
            type: "warning",
          }
        ).then(() => {
          window.location.href = `https://user.xpirory${location.host.substring(location.host.lastIndexOf('.'))}/login?lang=${this.currentLang == 'cn' ? 'zh' : this.currentLang}`;
        });
      }
    },
  },
  mounted() {
    // this.setRem();
    this.$store.commit('CHANGEWidth', document.documentElement.clientWidth);
    window.addEventListener('resize', () => {
      // 你的逻辑代码
      this.$store.commit('CHANGEWidth', document.documentElement.clientWidth);
    });
  },
};
</script>

<style lang="scss">
/*页面开始*/
html,
body,
#app {
  height: 100%;
  width: 100%;
}
</style>
